import { useRef } from "react";
import { UploadCloud, Loader2 } from "lucide-react";

export const ACCEPT = ".xlsx,.csv,.docx,.txt,.pdf,.png,.jpg,.jpeg,.webp";

export const UploadBox = ({ onFile, busy, title, hint, testid = "upload-box" }) => {
  const ref = useRef();
  return (
    <button type="button" disabled={busy} onClick={() => ref.current?.click()} data-testid={testid}
      onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); e.dataTransfer.files[0] && onFile(e.dataTransfer.files[0]); }}
      className="w-full rounded-lg border-2 border-dashed border-amber-300/70 bg-amber-50/40 hover:bg-amber-50/80 transition-colors p-8 text-center disabled:opacity-70">
      <input ref={ref} type="file" accept={ACCEPT} className="hidden" data-testid={`${testid}-input`}
        onChange={(e) => { e.target.files[0] && onFile(e.target.files[0]); e.target.value = ""; }} />
      {busy ? <Loader2 className="w-8 h-8 mx-auto animate-spin text-amber-600" /> : <UploadCloud className="w-8 h-8 mx-auto text-amber-600" />}
      <div className="mt-2 font-semibold text-slate-900">{busy ? "Reading your file with AI… this can take up to a minute" : title}</div>
      <div className="text-xs text-slate-500 mt-1">{hint || "Excel, CSV, Word, PDF or a photo/scan of the paper form · max 20 MB"}</div>
    </button>
  );
};
